import { EmployeeBankAccountMutationDTO } from "../../models/employee-bank-accounts/mutations/employee-bank-account-mutation-dto";
import { EmployeeBankAccountMutationSTO } from "../../models/employee-bank-accounts/mutations/employee-bank-account-mutation-sto";
import { MutationsFilter } from "../../models/mutations/mutations-filter";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeCurrentBankAccountMutationsApiService extends BaseApiService<
  EmployeeBankAccountMutationDTO,
  EmployeeBankAccountMutationSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeBankAccountMutations",
      loadItemsPath: "/GetCurrentEmployeeBankAccountMutations",
      saveItemsPath: "/SaveCurrentEmployeeBankAccountMutations",
    });
  }
}

export const loadEmployeeCurrentBankAccountMutations = async (
  employeeId: string,
  forManager: boolean,
  signal?: AbortSignal
) => {
  const apiService = new EmployeeCurrentBankAccountMutationsApiService();

  if (forManager) {
    apiService.useLoadItemsPath("/GetCurrentEmployeeBankAccountMutations");
  }
  const response = await apiService.loadItems(
    { employeeId } as MutationsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  return response;
};
